import React, {useEffect, useRef, useState} from 'react';
import Grid from "@material-ui/core/Grid";


import {withRouter} from 'react-router-dom';
import Box from "@material-ui/core/Box";
import useStyles from "../../styles";
import {useDispatch, useSelector} from "react-redux";
import EnhancedTable from "../../components/EnhancedTable";
import SiteWrapper from "../../SiteWrapper";
import Typography from "@material-ui/core/Typography";
import {httpWrapper} from "../../helper/Http";
import {contentTypeApplicationJson} from "../../constants/httpConstants";
import {utils} from "../../helper/Utils";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {useFormik} from "formik";
import dayjs from "dayjs"
import * as Yup from "yup";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DayjsUtils from "@date-io/dayjs";
import {getProductsAction} from "../../store/actions/ProductAction";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import {getSuppliersAction} from "../../store/actions/SupplierAction";
import ExportToPdfComponent from "../../components/ExportToPdfComponent";
import BreadCrumb from "../../components/BreadCrumb";
import TextField from "@material-ui/core/TextField/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";


const PurchaseLedgerPage = () => {

    const classes = useStyles();

    const dispatch = useDispatch();

    const [items, setItems] = useState([]);

    const products = useSelector(state => state.product.products);
    const suppliers = useSelector(state => state.supplier.suppliers);
    const [count, setCount] = useState(0);

    const [total, setTotal] = useState(0.00);

    const fetchIdRef = useRef(0);

    const url = '/reports/purchase-ledger/';


    const fetchData = React.useCallback((query, cb) => {

        const fetchId = ++fetchIdRef.current;

        if (fetchId === fetchIdRef.current) {

            httpWrapper.get(url, contentTypeApplicationJson, query).then(
                (response) => {

                    if (response.data) {
                        setItems(response.data.results.purchases);
                        setCount(response.data.results.purchases.length);
                        setTotal(utils.numberFormatter(response.data.results.purchases_total));
                    }

                    cb && cb();
                },
                (error) => {

                    cb && cb();
                }
            );
        }
    }, []);

    useEffect(() => {

        dispatch(getProductsAction());
        dispatch(getSuppliersAction());

        fetchData({
            start_date: utils.DEFAULT_START_DATE,
            end_date: utils.DEFAULT_END_DATE
        }, null);

    }, [dispatch, fetchData]);


    const formik = useFormik({

        initialValues: {

            start_date: utils.DEFAULT_START_DATE,
            end_date: utils.DEFAULT_END_DATE,
            product: '',
            supplier: '',
            generate_report: '',
        },

        validationSchema: Yup.object().shape({
            start_date: Yup.date("YYYY-mm-dd").required('Start date is required'),
            end_date: Yup.date("YYYY-mm-dd").required('End date is required'),
        }),

        onSubmit(values) {

            fetchData(values, callback);
        },

        enableReinitialize: true

    });

    const callback = () => {
        formik.setSubmitting(false);
    };

    const columns = [

        {
            Header: "Delivery Date",
            accessor: d => (dayjs(d.delivery_date).format(utils.dateFormat))
        },
        {
            Header: "Item",
            accessor: "product"
        },
        {
            Header: "Supplier",
            accessor: 'supplier'
        },
        {
            Header: "Reference",
            accessor: (d => d.reference ?? '-')
        },
        {
            Header: 'Quantity',
            accessor: (d => utils.numberFormatter(d.quantity))

        },
        {
            Header: 'Unit',
            accessor: (d => utils.numberFormatter(d.unit_price))

        },
        {
            Header: 'Vat (%)',
            accessor: (d => utils.numberFormatter(d.vat))

        },
        {
            Header: 'Total',
            accessor: (d => utils.numberFormatter(d.line_total))

        }
    ];

    return (
        <>
            <SiteWrapper>
                <BreadCrumb crumbs={[{
                    'name': 'Reports',
                    'link': '/reports'
                },
                    {
                        'name': 'Purchase Ledger',
                        'link': '#'
                    }]}/>
                <Grid container className={classes.marginTop}>
                    <Grid item xs={12} sm={4}>
                        <Box>
                            <Typography className={classes.medium}>
                                Purchases Ledger
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid container item xs={12} sm={8} justify="flex-end">
                        <Box>
                            {items && <ExportToPdfComponent url={url} values={formik.values}/>}
                        </Box>
                    </Grid>
                </Grid>

                <Grid container className={classes.marginTop}>

                    <form className={classes.form} onSubmit={formik.handleSubmit} noValidate>

                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={3}>
                                <MuiPickersUtilsProvider utils={DayjsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Start Date"
                                        maxDate={utils.maxDate}
                                        format="MM/DD/YYYY"
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        value={formik.values.start_date}
                                        onChange={val => formik.setFieldValue('start_date', dayjs(val).format("YYYY-MM-DD"))}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>


                            <Grid item xs={12} sm={3}>
                                <MuiPickersUtilsProvider utils={DayjsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="End Date"
                                        format="MM/DD/YYYY"
                                        maxDate={utils.maxDate}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        value={formik.values.end_date}
                                        onChange={val => formik.setFieldValue('end_date', dayjs(val).format("YYYY-MM-DD"))}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>


                            <Grid item xs={12} sm={3}>
                                {/*<FormControl className={clsx(classes.formControl, classes.formsWithMui)}>*/}
                                {/*    <InputLabel>Product</InputLabel>*/}
                                {/*    <Select*/}
                                {/*        name="product"*/}
                                {/*        onChange={formik.handleChange}*/}
                                {/*        value={formik.values.product || ''}*/}
                                {/*        error={formik.touched.product && Boolean(formik.errors.product)}*/}
                                {/*        helperText={formik.touched.product && formik.errors.product}*/}
                                {/*    >*/}
                                {/*        <MenuItem value="">Select Value</MenuItem>*/}
                                {/*        {products && products.map((m, idp) => <MenuItem*/}
                                {/*            value={m.id}*/}
                                {/*            key={idp}>{m.name}</MenuItem>)}*/}
                                {/*    </Select>*/}
                                {/*</FormControl>*/}
                                <Autocomplete
                                    filterOptions={utils.autocompleteFilterOptions}
                                    className={clsx(classes.formControl, classes.formsWithMui)}
                                    disablePortal
                                    options={products}
                                    getOptionLabel={option => option.name}
                                    name='product'
                                    defaultValue={formik.values.product || null}
                                    getOptionSelected={(option, value) => option.id === value.id}
                                    onChange={(_, value) => value != null ? formik.setFieldValue('product', value.id) : ''}
                                    renderInput={(params) => <TextField {...params}
                                                                        error={formik.errors.product && Boolean(formik.touched.product)}
                                                                        helperText={formik.errors.product && formik.touched.product}
                                                                        name='product'
                                                                        label="Spare"/>}
                                    classes={{paper: classes.autocomplete}}
                                />
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                <FormControl className={clsx(classes.formControl, classes.formsWithMui)}>
                                    <InputLabel>Supplier</InputLabel>
                                    <Select
                                        name="supplier"
                                        onChange={formik.handleChange}
                                        value={formik.values.supplier || ''}
                                        error={formik.touched.supplier && Boolean(formik.errors.supplier)}
                                        helperText={formik.touched.supplier && formik.errors.supplier}
                                    >
                                        <MenuItem value="">Select Value</MenuItem>
                                        {suppliers && suppliers.map((m, idp) => <MenuItem
                                            value={m.id}
                                            key={idp}>{m.name}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                    <Grid container justify="center">
                        <Button
                            onClick={formik.handleSubmit}
                            type="button"
                            size="small"
                            variant="contained"
                            color="secondary"
                            className={clsx(classes.primary, classes.formsWithMui)}
                            disabled={formik.isSubmitting}
                        >
                            Filter
                        </Button>
                    </Grid>
                </Grid>

                <Grid container justify="flex-end" className={classes.marginTop}>
                    {/* Recent Deposits */}
                    <Grid item xs={12} md={12} lg={12}>

                        {items && <EnhancedTable
                            columns={columns}
                            data={items}
                            summaries={[{
                                "title": "Total",
                                "value": total,
                                "colSpan": 3,
                                "freeSpan": 4
                            }]}
                            pageCount={count}
                        />}
                    </Grid>
                </Grid>
            </SiteWrapper>
        </>
    );
};

export default withRouter(PurchaseLedgerPage);